Namespace 'Keepcon'

class Keepcon.User extends Backbone.Model
  defaults:
    id: undefined,
    email: '',
    first_name: '',
    last_name: '',
    organization: ''

  fullName: ->
    "#{@get('first_name')} #{@get('last_name')}"
